<script src="../main.js"></script>
<template>
    <div class="wrap main-body">
        <div class="main-left">
            <div class="main-left-top">
                <p>일진그룹 방문예약 시스템에</p>
                <span>오신것을 환영합니다</span><br>
                <span>WELCOME TO ILJIN GROUP</span>
            </div>

            <div class="main-left-bottom">
                <div class="main-left-bottom-top">방문절차안내</div>
<!--                <div class="main-left-bottom-middle"><img src="/img/status1.jpg"/></div>-->
                <div class="main-left-bottom-middle">
                    <ul>
                        <li>
                            <div>
                                <img src="/img/status_01.gif">
                            </div>
                        </li>
                        <li class="arrow">
                            <div>
                                <img style="height:30px" src="/img/arrow.jpg">
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="/img/status_02.gif">
                            </div>
                        </li>
                        <li class="arrow">
                            <div>
                                <img style="height:30px" src="/img/arrow.jpg">
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="/img/status_03.gif">
                            </div>
                        </li>
                        <li class="arrow">
                            <div>
                                <img style="height:30px" src="/img/arrow.jpg">
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="/img/status_04.gif">
                            </div>
                        </li>
                        <li class="arrow">
                            <div>
                                <img style="height:30px" src="/img/arrow.jpg">
                            </div>
                        </li>
                        <li>
                            <div>
                                <img src="/img/status_05.gif">
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

        <div class="main-right">
            <div class="main-right-top">
                <p>방문예약 시스템으로</p>
                <p>신속한 방문신청이 가능합니다.</p>
            </div>
            <div class="main-right-middle">
                <img src="/img/main_monitor.png"/>
            </div>
            <router-link to="/visitProposal">
                <div class="main-right-bottom">
                    <span>방문신청하기</span>
                </div>
            </router-link>
        </div>
        <router-link to="/board/notice" style="color:#000">
            <div class="main-bottom-notice">
                <table style="border:none;">
                  <tr>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
<!--                <p>공지사항</p>-->
<!--                <span style="width:50%">2323232312121212</span>-->
<!--                <span style="width:40%">더보기</span>-->
            </div>
        </router-link>

        <router-link to="/board/faq" style="color:#000">
            <div class="main-bottom-faq">
                <p>FAQ</p>
                <span>더보기</span>
            </div>
        </router-link>

        <router-link to="/visitTerms">
            <div class="main-bottom-terms">
                <p>방문신청약관</p>
                <span>더보기</span>
            </div>
        </router-link>

        <router-link to="/visitPolicy">
            <div class="main-bottom-policy">
                <p>개인정보 처리방침</p>
                <span>더보기</span>
            </div>
        </router-link>
        <!-- footer -->
    </div>
    <!-- //wrap -->
</template>

<script>
    import DhxGrid from '@/components/DhxGrid.vue';
    import router from '@/router';


    export default {
        name: 'MyMain',
        components: {
            DhxGrid
        },
        data() {
            return {
                //메인화면 전체데이터
                mymains: [],
                //1.메인메뉴
                mainmenus:[],
                menuheads:[],
                menulink:[],
                //2.메인바로가기(퀵메뉴)
                mysets:[],
                myquicks:[],
                six:[],
                quickIcon:[],
                //3.메인법인카드내역
                unCardLists:[],
                uCard:[],
                //4.메인경비처리내역
                rcSlipLists:[],
                rcSlipData:[],
                //5. 사용현황
                psConds:[],
                piData:[],
                //6.메인처리예정건수
                uncounts: [],

            }
        },
        /* 숫자에 콤마(,)넣기*/
        filters:{
            currency:function (value) {
                var num = new Number(value);
                return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g,"$1,")
            }
        },

        mounted() {
        },
        methods: {
            //방문신청 클릭시 이동
            redirectPage() {
                this.$router.push({path: `/visitProposal`});
            },

            //로그아웃
            logout() {
                this.$http
                    .get('/logout')
                    .then(() => {
                        this.$store.commit('logout');
                        this.$cookie.delete('loginInfo');
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            },
        }
    };

</script>


<style scoped lang="scss">
    @import "public/css/main";

    .wrap.lnb.minimized~.contents2 {
        left: 50px;
    }

    /* contents */

    .contents2 {
        max-width: 100%;
        min-width: 1033px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 2;
        transition: .3s;
        padding: 0px 25px 33px 25px;
        /*overflow-y: auto;*/
    }


    .contents2>.inner-box {
        padding-bottom: 80px;
        min-height: 80vh;
    }

    .contents2 .content-name {
        margin-top: 33px;
    }

    .contents2 .content-name:after {
        clear: both;
        content: '';
        display: block;
    }

    .contents2 .content-name h2 {
        font-size: 24px;
        color: #061c3a;
        font-family: 'NotoM';
        float: left;
        line-height: 1;
    }

    .contents2 {
        /*overflow-y:auto;*/
        padding: 0;
    }

    .contents2>.inner-box {
        max-width: 100%;
        min-width: 1033px;
        padding: 0px 25px 33px 25px;
    }
    .contents2 div.gridbox_material.gridbox .xhdr {
        background: #f3f5f9;
        border-bottom: none;
        max-height: 100%;
        margin-top: -1px;
    }

    .contents2 .grid-tbl-box.type03 div.gridbox_material.gridbox .xhdr {
        height: 112px!important;
    }
    .contents2 div.gridbox_material.gridbox table.hdr td div.hdrcell {
        font-size: 14px;
        line-height: 24px;
        padding: 5.5px 0px;
        text-align: center;
        font-family: NotoM;
        color: #222;
    }
    .right .white-box .data-box{
        height: 239px;
    }

    .hdmenu {
        float: left;
        height: 50px;
        width: 700px;
        margin-left: 20px;
        line-height: 56px;
        font-size: 16px;
        padding-left: 50px;
    }

    ul {
        list-style:none;
        margin:0;
        padding:0;
    }

    li {
        margin: 0 80px 0 0;
        padding: 0 0 0 0;
        border : 0;
        float: left;
        font-size: 14px;
        color: #fff;
    }

    a{
        color: #d9ebff
    }
    a:hover {
        color: #fff
    }

    .main-body {
        position: absolute;
        width:95%;
        height: 90%;
        min-height:750px;
        top: 90px;
        left: 3%;
        margin: 0 auto;
        padding: 0 0 0;
        overflow: hidden;
    }
    .type-main {
        height:90%;
        overflow:auto;
    }
    .main-left-top{
        text-align: center;
        color:#fff;
    }
    .main-left-top p{
        font-size:25px;
        font-weight: bold;
    }
    .main-left-top span{
        font-size:22px;
    }
    .main-left-bottom{
        position: absolute;
        top:130px;
        width:100%;
        height:140px;
        background-color: #fff;
        /*opacity: 0.9;*/
        border-radius:4px;
    }
    .main-left-bottom-top{
        padding:5px 0 0 10px;
        width:100%;
        height:25%;
        text-align: left;
        background-color: #63727B;
        color:#fff;
        font-weight: bold;
        /*opacity: 0.9;*/
        border-radius:4px 4px 0 0;
    }
    .main-left-bottom-middle{
        padding-top:24px;
        width:100%;
        text-align: center;
    }
    .main-left-bottom-middle ul{
        position: relative;
        float: left;
        left: 5%;
        width: 100%;
        overflow: hidden;
        display: block;
    }
    .main-left-bottom-middle ul li.arrow {
        width: 2.5%;
        margin-top:10px;
    }
    .main-left-bottom-middle ul li{
        margin:0 5px 0 0;
        width:14%;
    }
    .main-left-bottom-middle ul li img{
        width: 45px;
    }
    .main-right{
        position: absolute;
        top:280px;
        border:1px solid #fff;
        width:100%;
        height:140px;
        background-color: #fff;
        border-radius: 4px;
        /*opacity: 0.9;*/
        text-align: center;
    }
    .main-right-top{
        position:absolute;
        width:100%;
        top:15px;
        font-size:15px;
        font-weight: bold;
    }
    .main-right-middle{
        position: absolute;
        top:5%;
        width:100%;
        text-align: right;
        display:none;
    }
    .main-right-middle img{
        width:170px;
    }
    .main-right-bottom{
        position:absolute;
        padding-top:10px;
        text-align: center;
        width:180px;
        top:75px;
        height:45px;
        border:1px solid #fff;
        background-color: #0066b3;
        cursor: pointer;
        border-radius: 4px;
        margin:0 auto;
        left:0px;
        right:0px;
    }
    .main-right-bottom a{
        color:#fff;
    }
    .main-right-bottom span{
        color:#fff;
        font-size:15px;
        font-weight: bold;
    }
    .main-bottom-notice{
        position: absolute;
        padding: 14px 0 0 30px;
        width:100%;
        top: 430px;
        height:50px;
        background-color: #fff;
        border-radius: 4px;
        font-weight: bold;
        font-size:15px;
        cursor: pointer;
        /*opacity: 0.9;*/
    }
    .main-bottom-notice span{
        position: absolute;
        top:15px;
        width:90%;
        text-align: right;
        font-size:12px;
    }
    .main-bottom-faq{
        position: absolute;
        padding: 14px 0 0 30px;
        width:100%;
        top: 490px;
        height:50px;
        background-color: #fff;
        border-radius: 4px;
        font-weight: bold;
        font-size:15px;
        cursor: pointer;
        /*opacity: 0.9;*/
    }
    .main-bottom-faq span{
        position: absolute;
        top:15px;
        width:90%;
        text-align: right;
        font-size:12px;
    }
    .main-bottom-terms{
        position: absolute;
        padding: 14px 0 0 30px;
        width:100%;
        top: 550px;
        height:50px;
        background-color: #0066b3;
        color:#fff;
        border-radius: 4px;
        font-weight: bold;
        font-size:15px;
        cursor: pointer;
        /*opacity: 0.9;*/
    }
    .main-bottom-terms span{
        position: absolute;
        top:15px;
        width:90%;
        text-align: right;
        font-size:12px;
    }
    .main-bottom-terms a{
        color:#fff;
    }
    .main-bottom-policy{
        position: absolute;
        padding: 14px 0 0 30px;
        width:100%;
        top: 610px;
        height:50px;
        background-color: #0066b3;
        color:#fff;
        border-radius: 4px;
        font-weight: bold;
        font-size:15px;
        cursor: pointer;
        /*opacity: 0.9;*/
    }
    .main-bottom-policy span{
        position: absolute;
        top:15px;
        width:90%;
        text-align: right;
        font-size:12px;
    }
    .main-bottom-policy a{
        color:#fff;
    }

    @media (min-width: 450px) {
        .main-body {
            position: absolute;
            width:95%;
            height: 90%;
            min-height:750px;
            top: 90px;
            left: 3%;
            margin: 0 auto;
            padding: 0 0 0;
            overflow: hidden;
        }
        .type-main {
            height:90%;
            overflow:auto;
        }
        .main-left-top{
            text-align: center;
            color:#fff;
        }
        .main-left-top p{
            font-size:28px;
            font-weight: bold;
        }
        .main-left-top span{
            font-size:24px;
        }
        .main-left-bottom{
            position: absolute;
            top:130px;
            width:100%;
            height:140px;
            background-color: #fff;
            /*opacity: 0.9;*/
            border-radius:4px;
        }
        .main-left-bottom-top{
            padding:5px 0 0 10px;
            width:100%;
            height:25%;
            text-align: left;
            background-color: #63727B;
            color:#fff;
            font-weight: bold;
            /*opacity: 0.9;*/
            border-radius:4px 4px 0 0;
        }
        .main-left-bottom-middle{
            padding-top:24px;
            width:100%;
            text-align: center;
        }
        .main-right{
            position: absolute;
            top:280px;
            border:1px solid #fff;
            width:100%;
            height:140px;
            background-color: #fff;
            border-radius: 4px;
            /*opacity: 0.9;*/
            text-align: left;
        }
        .main-right-top{
            position:absolute;
            margin-left:12%;
            width:100%;
            top:15px;
            font-size:16px;
            font-weight: bold;
        }
        .main-right-middle{
            position: absolute;
            top:5%;
            width:100%;
            text-align: right;
            display:block;
        }
        .main-right-middle img{
            width:170px;
        }
        .main-right-bottom{
            position:absolute;
            padding-top:10px;
            margin-left:12%;
            text-align: center;
            width:200px;
            top:75px;
            height:45px;
            border:1px solid #fff;
            background-color: #0066b3;
            cursor: pointer;
            border-radius: 4px;
        }
        .main-right-bottom span{
            color:#fff;
            font-size:15px;
            font-weight: bold;
        }
        .main-bottom-notice{
            position: absolute;
            padding: 14px 0 0 30px;
            width:100%;
            top: 430px;
            height:50px;
            background-color: #fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:15px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-notice span{
            position: absolute;
            top:15px;
            width:90%;
            text-align: right;
            font-size:12px;
        }
        .main-bottom-faq{
            position: absolute;
            padding: 14px 0 0 30px;
            width:100%;
            top: 490px;
            height:50px;
            background-color: #fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:15px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-faq span{
            position: absolute;
            top:15px;
            width:90%;
            text-align: right;
            font-size:12px;
        }
        .main-bottom-terms{
            position: absolute;
            padding: 14px 0 0 30px;
            width:100%;
            top: 550px;
            height:50px;
            background-color: #0066b3;
            color:#fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:15px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-terms span{
            position: absolute;
            top:15px;
            width:90%;
            text-align: right;
            font-size:12px;
        }
        .main-bottom-policy{
            position: absolute;
            padding: 14px 0 0 30px;
            width:100%;
            top: 610px;
            height:50px;
            background-color: #0066b3;
            color:#fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:15px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-policy span{
            position: absolute;
            top:15px;
            width:90%;
            text-align: right;
            font-size:12px;
        }
    }


    @media (min-width: 500px) {
        .main-left-top p{
            font-size:30px;
            font-weight: bold;
        }
        .main-left-top span{
            font-size:25px;
        }
        .main-right-top{
            position:absolute;
            margin-left:15%;
            width:100%;
            top:15px;
            font-size:18px;
            font-weight: bold;
        }
        .main-right-bottom{
            position:absolute;
            padding-top:9px;
            margin-left:15%;
            text-align: center;
            width:230px;
            top:75px;
            height:45px;
            border:1px solid #fff;
            background-color: #0066b3;
            cursor: pointer;
            border-radius: 4px;
        }
        .main-right-bottom span{
            color:#fff;
            font-size:17px;
            font-weight: bold;
        }
    }

    @media (min-width: 600px) {
        .main-right-top{
            position:absolute;
            margin-left:20%;
            width:100%;
            top:15px;
            font-size:19px;
            font-weight: bold;
        }
        .main-right-bottom{
            position:absolute;
            padding-top:9px;
            margin-left:20%;
            text-align: center;
            width:240px;
            top:80px;
            height:45px;
            border:1px solid #fff;
            background-color: #0066b3;
            cursor: pointer;
            border-radius: 4px;
        }
        .main-left-bottom-middle ul li{
            width:15%;
        }
    }

    @media (min-width: 700px) {
        .main-body {
            position: absolute;
            width:95%;
            /*height: 100%;*/
            min-height:900px;
            top: 90px;
            left: 3%;
            margin: 0 auto;
            padding: 0 0 0;
            overflow: hidden;
        }
        .type-main {
            height:90%;
            overflow:auto;
        }
        .main-left-top{
            text-align: center;
            color:#fff;
        }
        .main-left-top p{
            font-size:33px;
            font-weight: bold;
        }
        .main-left-top span{
            font-size:28px;
        }
        .main-left-bottom{
            position: absolute;
            top:150px;
            width:100%;
            height:140px;
            background-color: #fff;
            /*opacity: 0.9;*/
            border-radius:4px;
        }
        .main-left-bottom-top{
            padding:5px 0 0 10px;
            width:100%;
            height:25%;
            text-align: left;
            background-color: #63727B;
            color:#fff;
            font-weight: bold;
            /*opacity: 0.9;*/
            border-radius:4px 4px 0 0;
        }
        .main-left-bottom-middle{
            padding:22px;
            width:100%;
            text-align: center;
        }
        .main-left-bottom-middle ul{
            left: 4%;
        }
        .main-left-bottom-middle ul li.arrow {
            width: 2.5%;
            margin-top:15px;
        }
        .main-left-bottom-middle ul li{
            margin:0 5px 0 0;
            width:15%;
        }
        .main-left-bottom-middle ul li img{
            width:50px;
        }
        .main-right{
            position: absolute;
            top:300px;
            border:1px solid #fff;
            width:100%;
            height:200px;
            background-color: #fff;
            border-radius: 4px;
            /*opacity: 0.9;*/
        }
        .main-right-top{
            position:absolute;
            margin-left:16%;
            width:100%;
            top:20px;
            font-size:23px;
            font-weight: bold;
        }
        .main-right-middle{
            position: absolute;
            top:10%;
            width:100%;
            text-align: right;
        }
        .main-right-middle img{
            width:250px;
        }
        .main-right-bottom{
            position:absolute;
            padding-top:9px;
            margin-left:16%;
            text-align: center;
            width:290px;
            top:110px;
            height:50px;
            border:1px solid #fff;
            background-color: #0066b3;
            cursor: pointer;
            border-radius: 4px;
        }
        .main-right-bottom span{
            color:#fff;
            font-size:20px;
            font-weight: bold;
        }
        .main-bottom-notice{
            position: absolute;
            padding: 20px 0 0 30px;
            width:100%;
            top: 510px;
            height:70px;
            background-color: #fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:20px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-notice span{
            position: absolute;
            top:25px;
            width:90%;
            text-align: right;
            font-size:15px;
        }
        .main-bottom-faq{
            position: absolute;
            padding: 20px 0 0 30px;
            width:100%;
            top: 590px;
            height:70px;
            background-color: #fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:20px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-faq span{
            position: absolute;
            top:25px;
            width:90%;
            text-align: right;
            font-size:15px;
        }
        .main-bottom-terms{
            position: absolute;
            padding: 20px 0 0 30px;
            width:100%;
            top: 670px;
            height:70px;
            background-color: #0066b3;
            color:#fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:20px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-terms span{
            position: absolute;
            top:25px;
            width:90%;
            text-align: right;
            font-size:15px;
        }
        .main-bottom-policy{
            position: absolute;
            padding: 20px 0 0 30px;
            width:100%;
            top: 750px;
            height:70px;
            background-color: #0066b3;
            color:#fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:20px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-policy span{
            position: absolute;
            top:25px;
            width:90%;
            text-align: right;
            font-size:15px;
        }
    }

    @media (min-width: 900px) {
        .main-left-top p{
            font-size:33px;
            font-weight: bold;
        }
        .main-left-top span{
            font-size:28px;
        }
        .main-right-top{
            position:absolute;
            margin-left:20%;
            width:100%;
            top:20px;
            font-size:26px;
            font-weight: bold;
        }
        .main-right-bottom{
            position:absolute;
            padding-top:9px;
            margin-left:20%;
            text-align: center;
            width:330px;
            top:110px;
            height:50px;
            border:1px solid #fff;
            background-color: #0066b3;
            cursor: pointer;
            border-radius: 4px;
        }
        .main-right-bottom span{
            color:#fff;
            font-size:20px;
            font-weight: bold;
        }
    }

    @media (min-width: 1000px) {
        .main-body {
            width:1000px;
            height: 90%;
            min-height:730px;
            top:50px;
            left: 0;
            right: 0;
            overflow: hidden;
            padding-top:80px;
        }

        .type-main {
            height:90%;
            overflow:auto;
        }
        .main-left-top{
            text-align: center;
            color:#fff;
        }
        .main-left-top p{
            font-size:40px;
            font-weight: bold;
        }
        .main-left-top span{
            font-size:35px;
        }
        .main-left-bottom{
            position: absolute;
            top:300px;
            width:55%;
            height:150px;
            background-color: #fff;
            /*opacity: 0.9;*/
            border-radius:4px;
        }
        .main-left-bottom-top{
            padding:7px 0 0 10px;
            width:100%;
            height:25%;
            text-align: left;
            background-color: #63727B;
            color:#fff;
            font-weight: bold;
            /*opacity: 0.9;*/
            border-radius:4px 4px 0 0;
        }
        .main-left-bottom-middle{
            padding:20px;
            width:100%;
        }
        .main-left-bottom-middle ul{
            top:5px;
            left: 1%;
        }
        .main-left-bottom-middle ul li{
            width:16%;
        }
        .main-left-bottom-middle ul li img{
            width: 50px;
        }
        .main-right{
            position: absolute;
            left:57%;
            top:300px;
            border:1px solid #fff;
            width:43%;
            height:400px;
            background-color: #fff;
            border-radius: 4px;
            /*opacity: 0.9;*/
        }
        .main-right-top{
            position:absolute;
            margin-left:20%;
            width:100%;
            top:7%;
            font-size:22px;
        }
        .main-right-middle{
            position: absolute;
            top:27%;
            width:100%;
            text-align: center;
        }
        .main-right-middle img{
            width:300px;
        }
        .main-right-bottom{
            padding-top:12px;
            margin-left:30px;
            width:86%;
            top:315px;
            height:60px;
            border:1px solid #fff;
            background-color: #0066b3;
            cursor: pointer;
        }
        .main-right-bottom span{
            color:#fff;
            font-size:22px;
            font-weight: bold;
        }
        .main-bottom-notice{
            position: absolute;
            padding: 10px 0 0 30px;
            width:55%;
            top: 460px;
            height:50px;
            background-color: #fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:18px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-notice span{
            position: absolute;
            top:15px;
            width:50%;
            text-align: right;
            font-size:13px;
        }
        .main-bottom-faq{
            position: absolute;
            padding: 10px 0 0 30px;
            width:55%;
            top: 520px;
            height:50px;
            background-color: #fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:18px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-faq span{
            position: absolute;
            top:15px;
            width:90%;
            text-align: right;
            font-size:13px;
        }
        .main-bottom-terms{
            position: absolute;
            padding: 10px 0 0 30px;
            width:55%;
            top: 580px;
            height:50px;
            background-color: #0066b3;
            color:#fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:18px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-terms span{
            position: absolute;
            top:15px;
            width:90%;
            text-align: right;
            font-size:13px;
        }
        .main-bottom-policy{
            position: absolute;
            padding: 10px 0 0 30px;
            width:55%;
            top: 640px;
            height:50px;
            background-color: #0066b3;
            color:#fff;
            border-radius: 4px;
            font-weight: bold;
            font-size:18px;
            cursor: pointer;
            /*opacity: 0.9;*/
        }
        .main-bottom-policy span{
            position: absolute;
            top:15px;
            width:90%;
            text-align: right;
            font-size:13px;
        }
    }

</style>
